import { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import "../../assets/styles/components/tableAdd.scss";
import ImgHashtag from "../../assets/svg/hashtag.svg";
import ImgDelete from "../../assets/svg/icon-delete-show-account.svg";
import { BiTransferAlt } from "react-icons/bi";
import IconaddRow from "../../assets/svg/add-row.svg";
import { LuCopyCheck } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { formatNumber, formatPrice, setSelectItemLabels } from "../../helpers";
import { findValue, updateInput } from "../Input/functions";
import { apiGetAccountingTypeDetails, apiGetAccountingTypes } from "../../api/accountingTypeApi";
import { useLocation } from "react-router-dom";
import { apiGetProductWithBarcode, apiProductsList } from "../../api/productApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import getCurrency from "helpers/currencyHelper";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";
import { Divider, Tooltip } from "@mui/material";

const secretViewValue = "****";

export default function TableAdd({ input }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const store = useSelector((state) => state);
  const token = store.businessReducer.business?.token;
  const editItem = store.formReducer.editItem;
  const formType = input.formType
  const formData = store.formReducer;
  const products = store.productReducer?.products || [];
  const services = store.productReducer?.services || [];
  const remittance = store.formReducer.remittance;
  const secretView = store.appReducer.secretView;
  const accountingTypes = store.accountingReducer.accountingTypes || [];

  const currencies = store.currencyReducer.currencies;
  const otherCurrencies = store.currencyReducer.businessCurrencies;
  const business = store.businessReducer.business.business;
  const defaultCurrencyId=store.businessReducer.business.business.default_currency_id
  
  const currencyInputName = `${input.name}Currency`;
  const businessCurrencies = [
    currencies.find((c) => c.id === business.default_currency_id),
    ...otherCurrencies
  ];
  const [inputs, setInputs] = useState(input.inputs)

  const defaultValue = [
    { index: 0, unit: "main", discountType: "percent", discount: 0 },
    { index: 1, unit: "main", discountType: "percent", discount: 0 },
    { index: 2, unit: "main", discountType: "percent", discount: 0 },
    { index: 3, unit: "main", discountType: "percent", discount: 0 },
    { index: 4, unit: "main", discountType: "percent", discount: 0 }
  ];
  const [factorItems, setFactorItems] = useState(defaultValue);
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    dispatch(apiGetAccountingTypes(token));
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [remittance.items]);

  const updateValue = () => {
    const items = findValue(formData, input.formType, input.name, defaultValue);
    updateInput(dispatch, input.formType, input.name, items, input.primary);
    setFactorItems(items.length === 0 ? defaultValue : items);
  };

  const addRow = () => {
    let itemsRows;
    if (input.factorType === "accounting") {
      itemsRows = {
        unit: "main",
        quantity: 0,
        tax: 0,
        discountType: "percent",
        discount: 0,
        price: 0
      };
    } else {
      itemsRows = {
        unit: "main",
        quantity: 0,
        tax: 0,
        discountType: "percent",
        discount: 0,
        price: 0
      };
    }
    setFactorItems((prev) => {
      prev = [
        ...prev,
        {
          index: prev.length > 0 ? prev[prev.length - 1].index + +1 : 0,
          ...itemsRows
        }
      ];
      return prev;
    });
  };
  useKeyboardShortcuts([], (value) => {
    if (value.key === 'insert') {
      addRow()
    }
  });
  const updateInputValue = (value, key, index, parseInt = false) => {
    const newFactorItems = [];
    factorItems.map((f) => {
      if (f.index === index) {
        if (parseInt) {
          value = formatNumber(value);
        }

        f[key] = typeof value === "string" ? value.replaceAll(",", "") : value;

        if (input.formType === "accounting") {
          if (!f["currency"]) {
            f["currency"] = currencies[0];
          }
          if (key === "debtor") {
            f["creditor"] = 0
          }
          else if (key === "creditor") {
            f["debtor"] = 0
          }
          if ((key === "debtor" || key === "creditor" || key === "currency_exchange") && f["currency_exchange"]) {
            f["price"] = (f["debtor"] * 1 > 0) ? (f["debtor"] * 1) * (f["currency_exchange"] * 1) : (f["creditor"] * 1) * (f["currency_exchange"] * 1)
          }
        } else {
          let price = parseFloat(f.price);
          if (key === "unit") {
            const conversionRatio = f.product?.conversionRatio ?? 1;
            const quantity = value === "main" ? f.quantity * conversionRatio : f.quantity / conversionRatio;
            f["quantity"] = quantity > 1 ? quantity : "";

            if (value === "secondary") {
              price = price * conversionRatio;
            } else {
              price = price / conversionRatio;
            }
          }
          let discount = f.discountType === "price" ? f.discount ?? 0 : f.price * ((f.discount ?? 0) / 100);
          let tax = (f.price - discount) * ((f.tax ?? 0) / 100);

          f["price"] = price;
          f["totalPrice"] = f.quantity * (price + tax - discount);
        }
      }
      newFactorItems.push(f);
    });

    updateInput(dispatch, input.formType, input.name, newFactorItems, input.primary);
    setFactorItems(newFactorItems);
  };

  const renderInputs = (item, input, index) => {
    console.log(input.size, input.key)
    if (input.type === "text") {
      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <input
            className="form-control"
            disabled={input.disabled}
            type="text"
            name="name"
            defaultValue={input.defaultValue}
            value={secretView ? secretViewValue : item[input.key] ?? ""}
            onChange={(e) => updateInputValue(e.target.value, input.key, item.index)}
          />
        </div>
      );
    } else if (input.type === "price") {
      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <input
            className="form-control"
            disabled={input.disabled}
            type="text"
            name="name"
            defaultValue={input.defaultValue}
            value={secretView ? secretViewValue : formatPrice(item[input.key] ?? "")}
            onChange={(e) => {
              updateInputValue(e.target.value, input.key, item.index, true);
            }}
          />
        </div>
      );
    } else if (input.type === "discount") {
      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <input
            className="form-control"
            disabled={input.disabled}
            type="text"
            name="name"
            maxLength={item.discountType === "price" ? 10 : 2}
            defaultValue={input.defaultValue}
            value={secretView ? secretViewValue : formatPrice(item[input.key] ?? "")}
            onChange={(e) => updateInputValue(e.target.value, input.key, item.index, true)}
          />
          <button
            onClick={() => {
              updateInputValue(
                item.discountType === "price" ? "percent" : "price",
                "discountType",
                item.index
              );
            }}
            className="btn-table-add"
            type="button"
          >
            {item.discountType === "price"
              ? formData?.factor?.productCurrency?.en_title ??
              formData?.factor?.factorCurrency?.en_title ??
              getCurrency().defCur.en_title
              : "%"}
          </button>
        </div>
      );
    } else if (input.type === "percent") {
      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <input
            className="form-control"
            disabled={input.disabled}
            type="text"
            name="name"
            defaultValue={input.defaultValue}
            maxLength="2"
            value={secretView ? secretViewValue : formatNumber(item[input.key] ?? "")}
            onChange={(e) => updateInputValue(e.target.value, input.key, item.index, true)}
          />
          <button className="btn-table-add" type="button">
            %
          </button>
        </div>
      );
    } else if (input.type === "unit") {
      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <button
            onClick={() => {
              if (item[input.key] === "main") {
                updateInputValue("secondary", input.key, item.index);
              } else {
                updateInputValue("main", input.key, item.index);
              }
            }}
            className="btn-table-add position-relative"
            type="button"
          >
            {secretView
              ? secretViewValue
              : item[input.key] === "secondary"
                ? item.product?.subUnit ?? item.product?.unit ?? ""
                : item.product?.unit ?? ""}
          </button>
        </div>
      );
    } else if (input.type === "select") {
      const customStyles = {
        control: (provided, state) => ({
          ...provided,
          minHeight: 30,
          borderColor: "#c5c5c5",
          borderRadius: 8,
          marginTop: 2,
          marginBottom: 2,
          fontSize: 12,
          border: 0
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          height: 32,
          minWidth: "100px",
          marginTop: -5,
          border: 0
        }),
        option: (provided, state) => ({
          ...provided,
          minWidth: "100px",
          fontSize: 12,
          border: 0
        })
      };

      if (input.key === "product") {
        return (
          <div key={index} className="ps-4" style={{ width: `${input.size}px`, padding: "0px !important", position: "relative" }}>

            <BasicSelect
              key={item[input.key]?.value}
              options={products
                .concat(services)
                .map((p) => ({ ...p, label: p.accountingCode + " - " + p.title }))}
              withSearch
              withClear
              defaultValue={item[input.key]?.value || item?.ProductId || 0}
              btnStyle={{ border: 0, fontSize: 12 }}
              menuItemStyle={{ fontSize: 12 }}
              // style={{ minWidth: 200, maxWidth: 200 }}
              onChange={(value, option) => {
                changeProduct(option, input.key, item.index);
              }}
              onClear={() => {
                changeProduct(null, input.key, item.index);
              }}
              preferences={{
                size: 2
              }}
              withRefresh
              refreshList={() => {
                return dispatch(apiProductsList({ token, type: "all" }));
              }}
            />
          </div>
        );
      } else if (input.key === "accounting") {
        // return (!editItem || item.accounting) &&
        const a = accountingTypes?.all?.title;
        return (
          <div className="warp-select-box-tree" style={{ width: `${input.size}px` }}>
            <BasicSelect
              options={{
                title: accountingTypes?.all?.title,
                id: "main",
                childs: accountingTypes?.all?.childs.map((x) => ({ ...x, parentId: "main" }))
              }}
              defaultValue={item?.accounting?.id}
              btnStyle={{ border: 0 }}
              onChange={(val, option) => changeAccountingCode(item.index, input.key, option)}
              isNested
              withSearch
              preferences={{
                size: 2
              }}
              withRefresh
              refreshList={() => {
                dispatch(apiGetAccountingTypes(token, "all"));
              }}
            />
          </div>
        );
        // return (
        //   <AccountingTypesTable
        //     key={index}
        //     input={input}
        //     value={item.accounting}
        //     onChange={(index, key, value) => {
        //       // changeAccountingCode(item.index, key, value)
        //     }}
        //   />
        // );
      }
    } else if (input.type === "currency") {
      const customStyles = {
        control: (provided, state) => ({
          ...provided,
          minHeight: 30,
          height: "auto",
          borderColor: "#c5c5c5",
          borderRadius: 8,
          marginTop: 2,
          marginBottom: 2,
          fontSize: 12,
          border: 0
          // overflow: 'hidden'
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          height: 32,
          minWidth: "100px",
          marginTop: -5,
          border: 0
          // overflow: 'hidden'
        }),
        option: (provided, state) => ({
          ...provided,
          minWidth: "100px",
          fontSize: 12,
          border: 0
        })
      };

      return (
        <div key={index} className="input" style={{ width: `${input.size}px` }}>

          <Select
            styles={customStyles}
            isRtl={true}
            isMulti={input.multiple ?? false}
            placeholder={secretView ? secretViewValue : input.title}
            options={businessCurrencies}
            noOptionsMessage={({ inputValue }) => (!inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد")}
            value={secretView ? secretViewValue : item[input.key]}
            onChange={(value) => {
              changeCurrency(value, input.key, item.index);
            }}
          />
        </div>
      );
    } else if (input.type === "accountingDetail") {
      if (item.accounting?.details?.length) {
        return (
          <div className="input" style={{ width: `${input.size}px` }}>

            <BasicSelect
              options={item?.accounting?.details}
              defaultValue={item?.detail_id || item?.accounting?.detail?.id}
              withSearch
              btnStyle={{ border: 0 }}
              onChange={(val, option) => {
                let accounting = JSON.parse(JSON.stringify(item.accounting));
                accounting.detail = option;
                updateInputValue(accounting, "accounting", item.index);
              }}
              preferences={{
                size: 2
              }}
            />
          </div>
          // <AccountingDetails
          //   key={index}
          //   input={input}
          //   item={item}
          //   onChange={(value, item) => {
          //     let accounting = JSON.parse(JSON.stringify(item.accounting));
          //     accounting.detail = value;
          //     updateInputValue(accounting, "accounting", item.index);
          //   }}
          // />
        );
      } else {
        return <div key={index} className="input" style={{ width: `${input.size}px` }} />;
      }
    }
  };

  const changeAccountingCode = (index, key, item) => {
    const currencyId = formData?.accounting?.CurrencyId?.id || defaultCurrencyId
    ;
    dispatch(
      apiGetAccountingTypeDetails(item.id, token, (details) => {
        item.detail = null;
        item.details = details;
        updateInputValue(item, key, index);
      }, currencyId)
    );
  };

  const changeProduct = (product, key, index) => {
    if (product) {
      let duplicateRow = factorItems.find((f) => f.product && f.product.id === product.id);
      if (duplicateRow) {
        updateInputValue(+duplicateRow.quantity + 1, "quantity", duplicateRow.index);
        updateInputValue(null, key, index);
      } else {
        if (!index) {
          let emptyRow = factorItems.find((f) => !f.product);
          index = emptyRow.index;
        }

        product = setSelectItemLabels(product, "id", "title");
        const pr = input.factorType === "sell" ? product.sellPrice : product.buyPrice;

        const fc = formData.factor.factorCurrency;
        const pc = product.currency || businessCurrencies.find((x) => x.id === 1);

        const getPrice = (price, fc, pc) => {
          if (fc === pc) return price;
          const xr = (c) => (c && c.currencyExchange) || 1;
          return price * (xr(pc) / xr(fc));
        };

        const price = input.factorType && getPrice(pr, fc, pc);
        const tax = input.factorType && input.factorType === "sell" ? product.saleTax : product.buyTax;

        updateInputValue(product, key, index);
        updateInputValue('', "quantity", index);
        // updateInputValue("main", "unit", index);
        updateInputValue(tax ?? 0, "tax", index);
        updateInputValue(price ?? 0, "price", index);
        const lastRow = index === factorItems[factorItems.length - 1].index;
        lastRow && setTimeout(() => addRow(), 250);
        //   }
      }
    } else {
      updateInputValue(null, key, index);
      updateInputValue(null, "quantity", index);
      updateInputValue(null, "tax", index);
      updateInputValue(null, "price", index);
    }
  };

  const deleteRow = (index) => {
    setFlag(true);
    const newFactorItems = factorItems.filter((f) => f.index !== index);
    updateInput(dispatch, input.formType, input.name, newFactorItems, input.primary);
    setFactorItems(newFactorItems);
    setTimeout(() => {
      setFlag(false);
    }, 100);
  };

  const changeCurrency = (value, key, index) => {
    updateInputValue(value, key, index);
    // updateInputValue(value, key, index);
    // updateInputValue(1, "quantity", index);
    // updateInputValue(value.saleTax ?? 0, "tax", index);
    // updateInputValue((input.factorType && input.factorType === 'sell' ? value.sellPrice : value.buyPrice) ?? 0, "price", index);
  };

  const addProduct = (product) => product && changeProduct(product, "product");
  const copyUpperRow = (key, item) => {

    const beforeKey = key - 1
    const factorItem = { ...factorItems[beforeKey], index: key }
    const copyRows = [
      ...factorItems.slice(0, key),
      factorItem,
      ...factorItems.slice(key + 1)
    ];
    setFactorItems(copyRows)

  }
  const changeBedBes = (key, item) => {
    const factorItem = { ...factorItems[key] }
    const creditor = factorItem.creditor > 0 ? 0 : factorItem.debtor
    const debtor = factorItem.debtor > 0 ? 0 : factorItem.creditor
    const isCreditor = creditor > debtor
    updateInputValue(isCreditor ? creditor : debtor, isCreditor ? "creditor" : "debtor", key)
  }
  const [startWidth, setstartWidth] = useState(0)
  const getColSize = () => {

  }
  const changeColWidth = async (
    col,
    ev
  ) => {
    const colinfo = { ...col }
    if (ev.type === "dragstart") {
      setstartWidth(ev.clientX)
      ev.currentTarget.style.cursor = "col-resize"
      ev.target["startWidth"] = startWidth
    } else if (ev.type === "dragend") {
      let width = startWidth - ev.clientX
      width = Math.abs(col.size + width)
      colinfo.size = width > 500 ? 500 : width < 80 ? 80 : width
      const newInputs = [...inputs]
      const index = newInputs.findIndex(x => x.key === colinfo.key)
      newInputs[index] = { ...colinfo };
      setInputs(newInputs)
      setstartWidth(0)
    }
  }
  return (
    <div style={{ width: "100%", overflow: "auto" }}>
      <BarcodeReader
        onError={(err) => console.log(err)}
        onScan={(barcode) => {
          dispatch(apiGetProductWithBarcode(barcode, token, (product) => addProduct(product)));
        }}
      />
      <div className="wrap-table-add">
        <div className="body-table-add-new">
          <div className="table-header">
            <div>
              <img className="img-hashtag" src={ImgHashtag} alt="ImgHashtag" />
            </div>
            {inputs.map((input, index) => {
              return (
                <div key={index} style={{ width: `${input.size}px`, position: "relative" }}>
                  <Divider
                    draggable={true}
                    orientation='vertical'
                    onDragEndCapture={(e) => changeColWidth(input, e)}
                    onDragStartCapture={(e) => changeColWidth(input, e)}
                    sx={{
                      float: "left",
                      width: "2px",
                      height: 47 + (factorItems?.length * 41),
                      position: "absolute",
                      top: 0,
                      left: 0,
                      display: "inline-table",
                      borderColor: "#878787",
                      cursor: "col-resize",
                    }}
                  />
                  <p>{input.title}</p>
                </div>
              );
            })}
            <div className="action-delete-table-add" />
            {formType === "accounting" && <>
              <div className="action-delete-table-add" />

              <div className="action-delete-table-add" />
            </>
            }
          </div>
          {!flag &&
            factorItems.map((item, key) => {
              if (formType === "remittance") item.index = key
              return (
                <div key={key} className="table-body w-100">
                  <div className="table-body-row">
                    <div className="div-hashtag-new" style={{ width: 50 }}>
                      <p className="text-center">{key + 1}</p>
                    </div>
                    {inputs.map((input, index) => {
                      return renderInputs(item, input, index);
                    })}
                    <div className="action-delete-table-add" onClick={() => deleteRow(item.index)}>
                      <img src={ImgDelete} alt="ImgDelete" />
                    </div>
                    {formType === "accounting" && key > 0 ?
                      <Tooltip
                        slotProps={{
                          transition: { timeout: 200 },
                        }}
                        placement="top-start" title={"کپی سطر بالا"}>

                        <div className="action-delete-table-add" onClick={() => copyUpperRow(key, item)}>
                          <LuCopyCheck className="cursor-pointer" />
                        </div>
                      </Tooltip>
                      : null

                    }

                    {formType === "accounting" && <Tooltip
                      slotProps={{
                        transition: { timeout: 100 },
                      }}
                      placement="top-start" title={"جا به جایی بدهکار بستانکار"}>

                      <div className="action-delete-table-add" onClick={() => changeBedBes(key, item)}>
                        <BiTransferAlt className="cursor-pointer" />
                      </div>
                    </Tooltip>}
                  </div>
                </div>
              );
            })}
        </div>
        <div>
          <Tooltip title={"کلید میانبر (insert)"}>

            <div className="add-row" onClick={() => addRow()}>
              <div>
                <img src={IconaddRow} alt="IconaddRow" />
                افزودن ردیف
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
    </div >
  );
}
